<script>

import Input from "./Input.svelte";
import Icon from "../Icon.svelte"

import Button from "../Button.svelte"

import { icons } from './iconNames'
export let value = ""
export let defaultValue = "inherit"
export let defaultLabel = "Default"


let readableValue = value.split(".").length > 0 ? value.split(".")[0] : value
let searchResults = []

let lastSearch = ""

$: {
    if (lastSearch != readableValue) {
        lastSearch = readableValue
        let results = icons.search(readableValue)
        searchResults = results.splice(0, 100)
        // console.log(readableValue, results)
    }

    console.log("readableValue", readableValue)
}


</script>



<div class="" style="background-color: rgba(0,0,0,0.2); border-radius: 10px; padding: 10px; margin-top: 10px; margin-bottom: 10px;">
    <div class="row" style=" padding-top: 5px; padding-bottom: 13px; padding-left: 10px;"> 
        
        

        <div class="row" style="width: auto; justify-content: flex-start;">
            <Icon height="15px" name="magnifyingglass"></Icon>
            <input class="input inspector" bind:value={readableValue}/>
        </div>
        <span style="padding-right: 20px; font-size: 0.9rem !important;">
            <Button juicy={true} clear={true} action={() => {value = "none"; readableValue = ""}}>None</Button>
        </span>

    </div>
    

    <!-- <p>{value}</p> -->
    <!-- <Input autosize={false} isValid={() => true} bind:value={readableValue}></Input> -->
    <!-- <input bind:value={readableValue}/> -->

    <div class="row horizontal-scroll" style="">
    
        
        {#each searchResults as iconName (iconName)}
            <!-- svelte-ignore a11y-missing-attribute -->
    
            <Button clear={false} juicy={iconName == value} icon={iconName} iconOnly={true} action={() => {value = iconName;}} ></Button>
    
            <!-- <img alt="{iconName} icon" width="auto" height="25px" src={`../static/symbols/${iconName}.svg`}/> -->
        {/each}
    </div>
   
    <div class="row horizontal-scroll" style="margin-top: 8px;"><p on:click|passive style="margin-right: 13px;">{value}</p></div>
    

</div>



<style>


.row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    
    width: 100%;
}

.horizontal-scroll {
    overflow-y: scroll;
    white-space: nowrap;
    flex-wrap: wrap;
    max-height: 300px;
    justify-content: center;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

:global(.horizontal-scroll > a) {
    margin: 5px;
}

input.inspector, .input.inspector {
    background-color: rgba(0,0,0,0);
    border: 1px solid rgba(0,0,0,0);
    box-shadow: none;
    outline: none;
    color: var(--text-color);
    margin: 0px;
    padding: 3px 0px;
    border-radius: 0px;
    text-align: left;
    font-size: 0.9rem;
    min-width: 30px;
}

:global([contenteditable]) {
    -webkit-user-select: text;
    user-select: text;
}

.row > p {
    opacity: 0.618;
    height: 25px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
}


</style>